<template>
  <div class="footer">
  <!--
    <div class="links">
      <a href="http://www.jeecg.org" target="_blank">JEECG 首页</a>
      <a href="https://github.com/zhangdaiscott/jeecg-boot" target="_blank">
        <a-icon type="github"/>
      </a>
      <a href="https://ant.design/">Ant Design</a>
      <a href="https://vuecomponent.github.io/ant-design-vue/docs/vue/introduce-cn/">Vue Antd</a>
    </div>
    -->
    <div class="copyright">
      Copyright
      <a-icon type="copyright"/>
      2019-{{ currentYear }} <span>{{nameFull}} 版权所有 备案号：<a href="http://beian.miit.gov.cn/" target="_blank">{{beian}}</a></span>
      <!-- Copyright &copy; 2019-2020 机勘院 版权所有 -->
    </div>
  </div>
</template>

<script>
  import { getAction } from '@/api/manage'
  export default {
    name: "LayoutFooter",
    data () {
      return {
        nameFull: '',
        beian:'',
        currentYear: new Date().getFullYear()
      }
    },
    created () {
      //个性化首页和logo标识
      if(myPersonalizationSetData == null) {
        let wPath = window.location.href;
        getAction("/show/personalization/queryByPath", { 'path': wPath }).then((res) => {
          if (res.success) {
            //console.log(res.result);
            if (res.result) {
              myPersonalizationSetData = res.result;
            } else {
              myPersonalizationSetData = defaultPersonalizationSetData;
            }
          } else {
            myPersonalizationSetData = defaultPersonalizationSetData;
          }
          this.nameFull = myPersonalizationSetData.nameFull;
          this.beian = myPersonalizationSetData.beian;
        });
      }else{
        this.nameFull = myPersonalizationSetData.nameFull;
        this.beian = myPersonalizationSetData.beian;
      }

    },
  }
</script>

<style lang="scss" scoped>
  .footer {
    padding: 0 16px;
    margin: 48px 0 24px;
    text-align: center;

    .links {
      margin-bottom: 8px;

      a {
        color: rgba(0, 0, 0, .45);

        &:hover {
          color: rgba(0, 0, 0, .65);
        }

        &:not(:last-child) {
          margin-right: 40px;
        }
      }
    }
    .copyright {
      color: white;
      font-size: 14px;
    }
  }
</style>